const initialState = {
  requestingFetchOrderTypes: false,
  successfulFetchOrderTypes: false,
  errorsFetchOrderTypes: false,
  orderTypes: [],
};

const orderTypesReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_ORDER_TYPES_REQUESTING":
      return {
        ...state,
        requestingFetchOrderTypes: true,
        successfulFetchOrderTypes: false,
        errorsFetchOrderTypes: false,
      };
    case "FETCH_ORDER_TYPES_SUCCESS":
      return {
        ...state,
        requestingFetchOrderTypes: false,
        successfulFetchOrderTypes: true,
        orderTypes: action.value,
      };
    case "FETCH_ORDER_TYPES_ERROR":
      return {
        ...state,
        requestingFetchOrderTypes: false,
        successfulFetchOrderTypes: false,
        errorsFetchOrderTypes: true,
      };
    case "RESET_ORDER_TYPES_STATE":
      return {
        ...state,
        requestingFetchOrderTypes: false,
        successfulFetchOrderTypes: false,
        errorsFetchOrderTypes: false,
      };
    default:
      return state;
  }
};

export default orderTypesReducer;
